import React from 'react'
import { connect } from 'react-redux'
import setAddEventDialogStateAction from '../actions/events/setAddEventDialogStateAction'
import AddEventContainer from './addEventDialog.container';
import RaisedButton from 'material-ui/RaisedButton';
import {FormattedMessage} from 'react-intl';
import {AccountStatus} from "../utils/enumUtils";
import {Dialog, FlatButton} from "material-ui";
import history from '../routers/history';
import features from "../utils/features";

class AddEventInRoutesListContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openAddEventBlockedDialog: false
        }
    }



    handleOpenAddEventDialog = () => {
        this.props.setAddEventDialogState(true);
    };

    handleCloseAddEventDialog = () => {
        this.props.setAddEventDialogState(false);
    };

    openNewEventClicked = () => {
        if( this.props.account.status === AccountStatus.LIMITED && features.LimitedAccountsBlockOpenNewEvents ){
            this.setState({openAddEventBlockedDialog: true});
        }
        else{
            this.handleOpenAddEventDialog();
        }
    };

    handleCloseAddEventBlockedDialog = () => {
        this.setState({openAddEventBlockedDialog: false});
    };

    handleGoToYourAccount = () => {
        this.handleCloseAddEventBlockedDialog();
        history.push('/account');
    };

    render() {

        const customDialogStyle = {
            maxWidth: '450px',
        };
        const openAddEventBlockedDialogActions = [
            <FlatButton
                label= {<FormattedMessage id="general.closeText"/>}
                primary={false}
                onClick={this.handleCloseAddEventBlockedDialog.bind(this)}
            />,
            <FlatButton
                label= {<FormattedMessage id="account.goToMyAccountBtn"/>}
                primary={true}
                onClick={this.handleGoToYourAccount.bind(this)}
            />
        ];

        return (
            <div className="addEventDiv">
                <AddEventContainer
                    open = {this.props.addEventDialogState}
                    handleCloseDialog = {this.handleCloseAddEventDialog}
                />
                <Dialog
                    actions = {openAddEventBlockedDialogActions}
                    open = {this.state.openAddEventBlockedDialog}
                    onRequestClose = {this.handleCloseAddEventBlockedDialog.bind(this)}
                    contentStyle={customDialogStyle}
                >
                    <p><FormattedMessage id="account.newEventBlockedDialogText"/></p>
                </Dialog>
                <RaisedButton
                    labelColor = "#1789FC"
                    buttonStyle={{ borderRadius: 25 }}
                    style={{ borderRadius: 25 }}
                    label= {
                        <FormattedMessage
                            id = "sidemenu.createEventText"
                        />}
                    onTouchTap ={this.openNewEventClicked}>
                </RaisedButton>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    addEventDialogState:    state.events.addEventDialogState,
    account:                state.user.data.account
});

const mapDispatchToProps = {
    setAddEventDialogState: setAddEventDialogStateAction,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddEventInRoutesListContainer);



// WEBPACK FOOTER //
// ./src/containers/addEventInRoutesList.container.js